<template>
    <div>
        <div v-for="(pageQuestions, pageNumber) in questionsGroupedByPage" class="relative">
            <div v-for="question in pageQuestions" v-if="currentPage == pageNumber" class="list-animation question">
                <div class="question--label | text-xl | lg:text-2xl ">{{ question.question }} <span
                    class="text-yellow-600" v-if="question.required">*</span></div>
                <component :is="getComponentForQuestionType(question.question_type)" :question="question"></component>
            </div>
        </div>
    </div>
</template>
<style lang="scss">
    .question{
        &--label{
            @apply font-semibold text-primary-default mb-2;
        }
        &:not(:last-child){
            @apply mb-4
        }
    }
</style>
<script>
import { useStore } from 'vuex'
import {computed} from 'vue'
import {capitalize} from "lodash/string";

// Question types
import OpenQuestion from "./QuestionTypes/OpenQuestion";
import RadioQuestion from "./QuestionTypes/RadioQuestion";
import EmailQuestion from "./QuestionTypes/EmailQuestion";

export default {
    name: "QuestionsPage",
    components:{
        OpenQuestion,
        RadioQuestion,
        EmailQuestion
    },
    data() {
        return {

        }
    },
    mounted() {

    },
    setup(props){
        const store = useStore()

        return {
            currentPage: computed(() => store.state.currentPageNumber),
            totalPages: computed(() => store.state.totalPageCount),
            questions: computed(() => store.getters.questionsForCurrentPage),
            questionsGroupedByPage: computed(() => store.state.questionsGroupedByPage),
        }
    },
    methods:{
        getComponentForQuestionType(questionType){
            questionType = capitalize(questionType);
            return `${questionType}Question`;
        }
    },
    props: {

    }
}
</script>
